import { useState, useEffect } from "react";
import MainArea from "../components/MainArea";
import Sidebar from "../components/Sidebar";
import ResumePreview from "../components/ResumePreview";
import { Helmet } from "react-helmet-async";

function ResumeBuilder() {
  const [section, setSection] = useState("personal");

  const [resumeData, setResumeData] = useState({
    personal: { fullName: "", email: "", phone: "", location: "" },
    experience: [],
    education: [],
    skills: [],
    certificates: [],
    languages: [],
  });

  // Track screen width to determine mobile or desktop layout
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Handle input changes efficiently
  const handleChange = (section, index, field, value) => {
    setResumeData((prevData) => {
      if (section === "personal") {
        return {
          ...prevData,
          personal: { ...prevData.personal, [field]: value },
        };
      } else if (section === "skills") {
        return {
          ...prevData,
          skills: prevData.skills.map((skill, i) =>
            i === index ? value : skill
          ),
        };
      } else {
        return {
          ...prevData,
          [section]: prevData[section].map((item, i) =>
            i === index ? { ...item, [field]: value } : item
          ),
        };
      }
    });
  };

  // Add a new entry to a section
  const addSection = (section, defaultData) => {
    setResumeData((prevData) => ({
      ...prevData,
      [section]: [...prevData[section], defaultData],
    }));
  };

  // Remove an entry from a section
  const removeSection = (section, index) => {
    setResumeData((prevData) => ({
      ...prevData,
      [section]: prevData[section].filter((_, i) => i !== index),
    }));
  };

  return (
     <>
      <Helmet>
        <title>Online Resume Builder - Create ATS-Friendly CV | Build Pro Resume</title>
        <meta
          name="description"
          content="Use our intuitive resume builder to create a professional, ATS-optimized CV in minutes. Edit sections, preview in real-time, and download for free."
        />
        <meta
          name="keywords"
          content="Resume Builder, ATS Resume, Free Resume Generator, Build Resume Online"
        />
        <link rel="canonical" href="https://buildproresume.com/resume" />
      </Helmet>
    <div className={`flex h-screen ${isMobile ? "flex-col" : "flex-row"}`}>
      {/* Sidebar */}
      <aside
        className={`w-full ${
          isMobile ? "h-auto" : "lg:w-1/4 bg-gray-100 h-full"
        }`}
      >
        <Sidebar section={section} setSection={setSection} />
      </aside>

      {/* Main Content Area */}
      <main className={`p-4 overflow-auto ${isMobile ? "h-[60vh]" : "flex-1"}`}>
        <MainArea
          section={section}
          resumeData={resumeData}
          handleChange={handleChange}
          addSection={addSection}
          removeSection={removeSection}
        />
      </main>

      {/* Resume Preview */}
      <aside
        className={`w-full ${
          isMobile
            ? "h-[40vh] overflow-auto bg-gray-50 p-4"
            : "lg:w-1/3 bg-gray-50 p-4 h-full"
        }`}
      >
        <ResumePreview resumeData={resumeData} />
      </aside>
    </div>
    </>
  );
}

export default ResumeBuilder;
